import { processDate } from "../utils";
import { DATE_PICKER_COMPARE_TITLES, DATE_PICKER_RANGE_TITLES } from "../utils/datepicker";
import AppIcon from "./AppIcon.vue";
import FlexRow from "./FlexRow.vue";
import CalendarIcon from "./icons/CalendarIcon.vue";
import LoadingElement from "./shared/LoadingElement.vue";
export default {
  name: "DatePickerSelector",
  emits: ['click'],
  props: {
    selector: {
      type: Object
    },
    pillStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    dateStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: false,
      default: 200
    }
  },
  components: {
    FlexRow,
    AppIcon,
    LoadingElement,
    CalendarIcon
  },
  computed: {
    getPillStyle() {
      return {
        borderRadius: "24px",
        padding: "2px 8px",
        fontSize: "13px",
        fontWeight: "500",
        ...this.pillStyle
      };
    },
    getDateStyle() {
      return {
        color: "#757575",
        fontWeight: 500,
        lineHeight: "12px",
        fontSize: "12px",
        textAlign: "right",
        ...this.dateStyle
      };
    },
    formattedRange() {
      if (!this.selector?.range) return null;
      return this.formatRange(this.selector?.range);
    },
    formattedCompare() {
      console.log('Formatted Compare', this.selector);
      if (!this.selector?.compare) return null;
      return this.formatRange(this.selector?.compare);
    },
    turnOffCompare() {
      return this.selector?._compareTitle === DATE_PICKER_COMPARE_TITLES.CUSTOM && this.selector?._title === DATE_PICKER_RANGE_TITLES.CUSTOM;
    }
  },
  methods: {
    formatRange(range) {
      let {
        start,
        end
      } = range ?? {
        start: null,
        end: null
      };
      start = processDate(start.date, start.format);
      end = processDate(end.date, end.format);
      return `${start} - ${end}`;
    }
  }
};